/**
 * `const Name` is what keeps the literal type: without it every constant would
 * widen to `Permission<string>` and the catalogue's union of names — the type
 * the grant check refuses a name outside of — would collapse to
 * `string`.
 */
export function definePermission(name, description) {
    return Object.freeze({ name, description });
}
/**
 * The wildcard the `admin` role holds. It is not a catalogue entry — nothing
 * grants it individually — but it is a grantable name, so it has to be part of
 * the type a role's permission list is written in.
 *
 * Matching it is `PermissionName.matches` in `@repo/kernel`, never
 * `includes()`: a literal comparison misses `*` and `resource:*` in the
 * permissive direction, which arrives as a support ticket rather than a breach
 * and is therefore fixed by whoever is in a hurry.
 */
export const PERMISSION_WILDCARD = "*";
//# sourceMappingURL=permission.js.map